import type { ReactNode } from 'react';

/**
 * Iconițele aplicației, desenate în casă ca și graficul de prețuri: câteva
 * simboluri nu merită o bibliotecă întreagă în pachet.
 *
 * Toate pe caroiaj de 16, numai contur, `currentColor`: iau culoarea locului
 * în care stau, deci se sting și se aprind odată cu textul, fără reguli în plus.
 */
export function Icon({ children }: { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}
